// extracted by mini-css-extract-plugin
export default {"searchResults":"searchResults_searchResults__xBX-U","stopItems":"searchResults_stopItems__xfll9"};